import {configureStore} from "@reduxjs/toolkit";
import {userPersistedReducer} from "../persist/userPersistedReducer";
import {cartPersistedReducer} from "../persist/cartPersistedReducer";
import laximoReducer from "../slices/laximoSlice";
import userSlice from "@/utils/storage/slices/userSlice.ts";
import cartSlice from "@/utils/storage/slices/cartSlice.ts";
import {FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE} from "redux-persist";

/** Создание хранилища */
export const makeStore = () => {
    const isClient = typeof window !== 'undefined';

    if (isClient) {
        // Клиентская конфигурация с persisted reducers
        return configureStore({
            reducer: {
                user: userPersistedReducer,
                cart: cartPersistedReducer,
                laximo: laximoReducer,
            },
            middleware: (getDefaultMiddleware) => getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
            }),
        });
    } else {
        // SSR конфигурация с обычными reducers
        return configureStore({
            reducer: {
                user: userSlice,
                cart: cartSlice,
                laximo: laximoReducer,
            },
            middleware: (getDefaultMiddleware) => getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
            }),
        });
    }
};
